module.exports = __webpack_public_path__ + "static/img/VENICE_PAINT.8e78a80.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/VENICE_PAINT.jpg
// module id = B8Rr
// module chunks = 0